import { render, staticRenderFns } from "./sites.vue?vue&type=template&id=dc0b0daa&scoped=true"
import script from "./sites.vue?vue&type=script&lang=ts"
export * from "./sites.vue?vue&type=script&lang=ts"
import style0 from "./sites.vue?vue&type=style&index=0&id=dc0b0daa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0b0daa",
  null
  
)

export default component.exports